import React from 'react';

const InvalidPermissions = props => {
    return <div className="alert alert-danger">
        <h4>Insufficient Permissions</h4>
        <p>You don't have the correct permissions to edit Embeded Preferences. Please contact your Account Administrator should you feel this to be a mistake.</p>
    </div>
}

export default InvalidPermissions;
